import { RootState } from "../../../../store";
import { widgetSetupSelector } from "../widgetSetupSelector";
import { LargestCostChangesSetupType } from "../../../utils/types/setups/largestCostChangesSetupType";

export const largestCostChangesSetupSelector = (
  state: RootState,
): LargestCostChangesSetupType | undefined => {
  if (!widgetSetupSelector(state)) {
    return;
  }
  return widgetSetupSelector(state) as LargestCostChangesSetupType;
};
